import React from 'react';
import {
  DatePicker, Icon, Form, InputNumber, Input, Selector,
} from '@roo/roo';
import dayjs from 'dayjs';
import { FieldList } from '../../_components/FieldList';
import { UploadField } from '../../_components/UploadField';
import {
  requiredRule, getRuleLen, getRuleNumber, stringWithoutNumberRule,
} from '../../../../utils/rules';
import { getPopContainer } from '../../_utils';
import { getSafeDate } from '../../../../utils/utils';

const Field = Form.Field;
const { Textarea } = Input;

const signList = [
  { value: '唯一第一作者', label: '唯一第一作者' },
  { value: '共同第一作者', label: '共同第一作者' },
  { value: '唯一通讯作者', label: '唯一通讯作者' },
  { value: '共同通讯作者', label: '共同通讯作者' },
  { value: '非通讯且非第一作者', label: '非通讯且非第一作者' },
];

const paperObj = {
  paperName: '',
  journalName: '',
  publishTime: '',
  referenceNumber: 0,
  paperUrl: '',
};
const honorObj = {
  getTime: '',
  honorName: '',
  projectName: '',
  honorRank: '',
  intitutionName: '',
  fileUrl: [],
};
const patentObj = {
  nation: '',
  type: '',
  name: '',
  rank: '',
  fileNumber: '',
  fileUrl: '',
};

function Paper(props) {
  const { honor = [], patent = [] } = props.values;
  return (
    <>
      <div className="patch-tips" style={{ marginTop: 32 }}>
        <span className="form-field-title-tip">代表性论文（近5年内发表）</span>
        <div className="info">
          <Icon name="info-circle-o" />
          请提供不超过5篇本人发表的、与工作规划相关的代表性论文、著作，建议填写申报人作为一作或通讯作者发表的作品。
        </div>
      </div>
      <FieldList
        {...props}
        name="paper"
        maxCount={5}
        minCount={1}
        iniData={paperObj}
        plusText="添加论文著作"
        itemClassName="form-patch bc"
      >
        <Field
          required
          label="篇&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名"
          name="paperName"
          rule={getRuleLen(400, true)}
          as={<Input maxLength={400} placeholder="请输入篇名" />}
        />
        <Field
          required
          label="期&nbsp;&nbsp;刊&nbsp;名"
          name="journalName"
          rule={getRuleLen(200, true)}
          as={<Input maxLength={200} placeholder="请输入期刊名" />}
        />

        <Field required label="发表时间" name="publishTime" rule={{ ...requiredRule }}>
          {({ value, handleChange, disabled }) => (
            <DatePicker
              flip
              clearable
              disabled={disabled}
              value={getSafeDate(value)}
              format="YYYY-MM-DD"
              valueOfType="string"
              placeholder="请提供近五年发表的论文"
              disabledDate={(cur) => cur.isBefore(dayjs('2018-1-1'))}
              popupContainer={getPopContainer}
              onChange={(value) => {
                handleChange(value);
              }}
            />
          )}
        </Field>
        <Field
          required
          label="本人署名情况"
          name="authorType"
          rule={getRuleLen(50, true)}
          as={<Selector options={signList} filterable disablePortal />}
        />
        <Field
          required
          hid
          rule={requiredRule}
          label="主要合作作者"
          name="mainCoAuthor"
          as={<Input maxLength={50} placeholder="请输入" />}
        />
        {/* <Field
          required={true}
          label='作&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;者'
          name={`author`}
          rule={getRuleLen(50, true)}
          as={<Input maxLength={50} placeholder='作者' />}
        /> */}
        <Field
          required
          rule={getRuleNumber(true, 9999999999)}
          label="他引次数"
          name="referenceNumber"
          placeholder="他引次数"
          as={<InputNumber style={{ width: '100%' }} max={9999999999} min={0} />}
        />
        <Field label="论文上传" required rule={{ ...requiredRule, message: '论文必须上传' }} layout="vertical" name="paperUrl">
          {({ value, handleChange }) => <UploadField type="doc" value={value} handleChange={handleChange} />}
        </Field>
      </FieldList>
      <div className="patch-tips">
        <span>个人曾获学术奖励</span>
        <div className="info">
          <Icon name="info-circle-o" />
          若有，请提供不超过三项曾获得的重要学术奖励。
        </div>
      </div>
      <FieldList
        {...props}
        name="honor"
        maxCount={3}
        minCount={0}
        iniData={honorObj}
        plusText="添加学术奖励"
        itemClassName="form-patch bc"
      >
        <Field
          required
          label="奖项名称"
          name="honorName"
          rule={getRuleLen(50, true)}
          as={<Input maxLength={50} placeholder="请输入获奖名称" />}
        />
        <Field
          required
          label="授奖机构名称"
          name="institutionName"
          placeholder="请输入授奖机构"
          rule={getRuleLen(200, true)}
          as={<Input maxLength={200} placeholder="请输入授奖机构" />}
        />
        <Field
          required
          label="获奖时间"
          name="getTime"
          placeholder="请选择获奖时间"
          rule={requiredRule}
        >
          {({ value, handleChange, disabled }) => (
            <DatePicker
              flip
              value={getSafeDate(value)}
              disabled={disabled}
              format="YYYY-MM-DD"
              valueOfType="string"
              placeholder="获奖时间"
              onChange={handleChange}
              popupContainer={getPopContainer}
            />
          )}
        </Field>
        <Field
          required
          label="奖项等级及排名"
          name="honorRank"
          rule={{ ...getRuleLen(50, false), ...requiredRule }}
          as={<Input maxLength={50} placeholder="请输入等级排名" />}
        />
        <Field
          required
          rule={requiredRule}
          label="获奖原因及主要贡献"
          name="description"
          as={<Textarea maxLength={1000} placeholder="请输入获奖原因及主要贡献" />}
        />
        <Field label="证书上传" required rule={{ ...requiredRule, message: '证书必须上传', type: 'array' }} layout="vertical" name="fileUrl">
          {({ value, handleChange }) => (
            <UploadField maxFiles={5} type="imgpdf" value={value} handleChange={handleChange} />
          )}
        </Field>
      </FieldList>
      <div className="patch-tips">
        <p>知识产权情况</p>
        <div className="info">
          <Icon name="info-circle-o" />
          若有，请提供不超过五项，与项目内容相关的授权知识产品。
        </div>
      </div>
      <FieldList
        {...props}
        name="patent"
        maxCount={5}
        minCount={0}
        iniData={patentObj}
        plusText="添加知识产权情况"
        itemClassName="form-patch bc"
      >
        <Field
          required
          rule={stringWithoutNumberRule()}
          label="国&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别"
          name="nation"
          as={<Input maxLength={50} placeholder="请输入国别" />}
        />
        <Field
          required
          rule={getRuleLen(50, true)}
          label="产权类别"
          name="type"
          as={<Input maxLength={50} placeholder="专利权、著作权、商标权等" />}
        />

        <Field
          required
          rule={getRuleLen(300, true)}
          label="知识产权名称"
          name="name"
          as={<Input maxLength={300} placeholder="请输入知识产权名称" />}
        />
        <Field
          required
          rule={getRuleLen(50, true)}
          label="名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;次"
          name="rank"
          as={<Input maxLength={50} placeholder="请输入申报人为第几完成人" />}
        />
        <Field
          required
          rule={getRuleLen(50, true)}
          label="申请号/登记号/授权号"
          name="fileNumber"
          as={<Input maxLength={50} placeholder="请输入知识产权授权号" />}
        />
        <Field label="知识产权文件上传" required rule={{ ...requiredRule, message: '知识产权必须上传' }} layout="vertical" name="fileUrl">
          {({ value, handleChange }) => (
            <UploadField maxFiles={1} type="imgpdf" value={value} handleChange={handleChange} />
          )}
        </Field>
      </FieldList>
    </>
  );
}

export default Paper;
